import Vue from 'vue';
import jApi from './jApi';

export default {
  getSideMenuList(applicationId, params) {
    const api = jApi.generateApi();
    return api.get(`/dynamic-apps/applications/${applicationId}/pages`, params)
      .then(res => res.data);
  },

  getApplicationDetail(applicationId, params) {
    const api = jApi.generateApi();
    return api.get(`/dynamic-apps/applications/${applicationId}`, params)
      .then(res => res.data);
  },

  // SERVICES IN SETTING TAB
  // get form_ids
  listComponent(params, id) {
    const api = jApi.generateApi();
    return api.get(`dynamic-apps/studio/pages/${id}/components`, { params })
      .then(res => res.data);
  },

  saveComponent(req) {
    const api = jApi.generateApi();
    return api.post('dynamic-apps/studio/components', req.data)
      .then(res => res.data);
  },

  updateComponent(req) {
    const api = jApi.generateApi();
    return api.patch(`dynamic-apps/studio/components/${req.component_id}`, req.data)
      .then(res => res.data);
  },

  deleteComponent(req) {
    const api = jApi.generateApi();
    return api.delete(`dynamic-apps/studio/components/${req.component_id}`)
      .then(res => res.data);
  },

  listComponentMaster(params) {
    const api = jApi.generateApi();
    return api.get('dynamic-apps/components-master', { params })
      .then(res => res.data);
  },

  // BOARD COMPONENT
  getListBoard() {
    const api = jApi.generateApi();
    return api.get('board-service/boards')
      .then(res => res.data);
  },

  // FORM COMPONENT
  createForm(req) {
    const api = jApi.generateApi();
    return api.post('/jojoform/additional-info/form/create', req)
      .then(res => res.data);
  },

  createBoards(req) {
    const api = jApi.generateApi();
    return api.post('board-service/boards', req)
      .then(res => res.data);
  },

  getListForm(req) {
    const api = jApi.generateApi();
    return api.post('/jojoform/additional-info/form/data-table', req)
      .then(res => res.data);
  },

  detailForm(req) {
    const api = jApi.generateApi();
    return api.post('/jojoform/additional-info/form/detail', req)
      .then(res => res.data);
  },

  // CHANNEL COMPONENT
  getListChannel() {
    const api = jApi.generateJojoChatApi();
    // return api.get('jojonomic/api/v1/channels.list')
    return api.get('jojonomic/api/v1/rooms.get')
      .then(res => res.data);
  },

  // DISCUSSION COMPONENT
  getListDiscussion() {
    const api = jApi.generateJojoChatApi();
    return api.get('jojonomic/api/v1/channels.list')
      .then(res => res.data);
  },

  // SERVICES IN PAGES TAB
  getListRule(req) {
    const api = jApi.generateApi();
    return api.post('/jojoflow/rule/list', req)
      .then(res => res.data);
  },

  detailRule(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/rule/detail', req)
      .then(res => res.data);
  },

  getOrganigramId(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/rule/detail-with-organigram-ids', req)
      .then(res => res.data);
  },

  createOrganigramFormRule(req) {
    const api = jApi.generateApi();
    return api.post('jojoform-transaction/setup/organigram-form-rule/create', req)
      .then(res => res.data);
  },

  getListWidget(req) {
    const api = jApi.generateApi();
    return api.get('dynamic-apps/widget-master', req)
      .then(res => res.data);
  },

  getListIcons(req) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/icon', { params: req })
      .then(res => res.data);
  },

  updatePage(params) {
    const data = {
      application_id: params.application_id,
      name: params.name,
      type: params.type,
      show_option: params.show_option,
      icon_id: params.icon_id,
      order: params.order,
    };

    if (params.parent_id) {
      Object.assign(data, {
        parent_id: params.parent_id,
      });
    }

    const api = jApi.generateApi();
    return api.patch(`/application-pages/studio/pages/${params.page_id}`, data)
      .then(res => res.data);
  },

  getDashboardList() {
    const token = Vue.ls.get('Token');
    const api = jApi.generateApiDashboard();
    return api.get(`jojodashboard-embed/list?token=${token}`)
      .then(res => res.data).catch(() => {
        // eslint-disable-next-line
        console.log('Error obtaining QuickSight dashboard list.');
      });
  },

  getDashboardUrl(code) {
    const token = Vue.ls.get('Token');
    const api = jApi.generateApiDashboard();
    return api.get(`jojodashboard-embed/getUrl?code=${code}&token=${token}`)
      .then(res => res.data).catch(() => {
        // eslint-disable-next-line
        console.log('Error obtaining QuickSight dashboard embed url.');
      });
  },

  getDynamicWorkflow(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-workflow/workflow', params)
      .then(res => res.data);
  },
  findDynamicWorkflow(params) {
    const api = jApi.generateApi();
    return api.get(`/dynamic-workflow/workflow/${params}`)
      .then(res => res.data);
  },
  createDynamicWorkflow(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-workflow/workflow', params)
      .then(res => res.data);
  },
  updateDynamicWorkflow(id, params) {
    const api = jApi.generateApi();
    return api.patch(`/dynamic-workflow/workflow/${id}`, params)
      .then(res => res.data);
  },
  deleteDynamicWorkflow(params) {
    const api = jApi.generateApi();
    return api.delete(`/dynamic-workflow/workflow/${params}`)
      .then(res => res.data);
  },

  // workflow status endpoint
  getDynamicWorkflowStatus(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-workflow/workflow-status', params)
      .then(res => res.data);
  },
  findDynamicWorkflowStatus(params) {
    const api = jApi.generateApi();
    return api.get(`/dynamic-workflow/workflow-status/${params}`)
      .then(res => res.data);
  },
  createDynamicWorkflowStatus(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-workflow/workflow-status', params)
      .then(res => res.data);
  },
  updateDynamicWorkflowStatus(id, params) {
    const api = jApi.generateApi();
    return api.patch(`/dynamic-workflow/workflow-status/${id}`, params)
      .then(res => res.data);
  },
  deleteDynamicWorkflowStatus(params) {
    const api = jApi.generateApi();
    return api.delete(`/dynamic-workflow/workflow-status/${params}`)
      .then(res => res.data);
  },

  // workflow status endpoint
  getDynamicWorkflowTransaction(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-workflow/transaction-status', params)
      .then(res => res.data);
  },
  findDynamicWorkflowTransaction(params) {
    const api = jApi.generateApi();
    return api.get(`/dynamic-workflow/transaction-status/${params}`)
      .then(res => res.data);
  },
  createDynamicWorkflowTransaction(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-workflow/transaction-status', params)
      .then(res => res.data);
  },
  updateDynamicWorkflowTransaction(id, params) {
    const api = jApi.generateApi();
    return api.patch(`/dynamic-workflow/transaction-status/${id}`, params)
      .then(res => res.data);
  },
  deleteDynamicWorkflowTransaction(params) {
    const api = jApi.generateApi();
    return api.delete(`/dynamic-workflow/transaction-status/${params}`)
      .then(res => res.data);
  },

  createFormula(req) {
    const api = jApi.generateApi();
    return api.post('dynamic-apps/formula', req)
      .then(res => res.data);
  },

  // formula operation section
  getFormulaOperationsByFormula(id, req) {
    const api = jApi.generateApi();
    return api.get(`dynamic-apps/formula/${id}/formula-operation`, req)
      .then(res => res.data);
  },

  createFormulaOperation(req) {
    const api = jApi.generateApi();
    return api.post('dynamic-apps/formula-operation', req)
      .then(res => res.data);
  },

  updateFormulaOperation(id, req) {
    const api = jApi.generateApi();
    return api.patch(`dynamic-apps/formula-operation/${id}`, req)
      .then(res => res.data);
  },

  deleteFormulaOperation(req) {
    const api = jApi.generateApi();
    return api.delete(`dynamic-apps/formula-operation/${req}`)
      .then(res => res.data);
  },

  // operation section
  getOperationsByFormulaOperation(id, req) {
    const api = jApi.generateApi();
    return api.get(`dynamic-apps/formula-operation/${id}/operations`, req)
      .then(res => res.data);
  },

  createOperation(req) {
    const api = jApi.generateApi();
    return api.post('dynamic-apps/operations', req)
      .then(res => res.data);
  },

  updateOperation(id, req) {
    const api = jApi.generateApi();
    return api.patch(`dynamic-apps/operations/${id}`, req)
      .then(res => res.data);
  },

  deleteOperation(req) {
    const api = jApi.generateApi();
    return api.delete(`dynamic-apps/operations/${req}`)
      .then(res => res.data);
  },

  // WIDGET
  getCompanyBanner(params) {
    const api = jApi.generateApi();
    return api.get('dynamic-apps/company-banner', { params })
      .then(res => res.data);
  },

  createCompanyBanner(payload) {
    const api = jApi.generateApi();
    return api.post('dynamic-apps/company-banner', payload)
      .then(res => res.data);
  },

  setCompanyBanner(payload) {
    const api = jApi.generateApi();
    return api.patch(`dynamic-apps/company-banner/${payload.id}`, payload)
      .then(res => res.data);
  },

  getListWidgetMaster(params) {
    const api = jApi.generateApi();
    return api.get('dynamic-apps/widget-master', { params })
      .then(res => res.data);
  },

  getListWidgetDetail(params) {
    const api = jApi.generateApi();
    return api.get('dynamic-apps/widgets', { params })
      .then(res => res.data);
  },

  createWidget(req) {
    const api = jApi.generateApi();
    return api.post('dynamic-apps/widgets', req)
      .then(res => res.data);
  },

  updateWidget(id, req) {
    const api = jApi.generateApi();
    return api.patch(`dynamic-apps/studio/widgets/${id}`, req)
      .then(res => res.data);
  },

  deleteWidget(req) {
    const api = jApi.generateApi();
    return api.delete(`dynamic-apps/widgets/${req.id}`)
      .then(res => res.data);
  },

  // BOARD
  getListBoardSetting() {
    const api = jApi.generateApi();
    return api.get('board-service/boards')
      .then(res => res.data);
  },

  getBoardDetailSetting(id) {
    const api = jApi.generateApi();
    return api.get(`board-service/boards/${id}`)
      .then(res => res.data);
  },

  // createBoardSetting(req) {
  //   const api = jApi.generateApi();
  //   return api.post('board-service/boards', req)
  //     .then(res => res.data);
  // },

  // deleteBoardSetting(req) {
  //   const api = jApi.generateApi();
  //   return api.delete('board-service/boards', req)
  //     .then(res => res.data);
  // },
};




// WEBPACK FOOTER //
// ./src/services/jApiApplication.js